export enum FontWeight {
  NORMAL = '400',
  BOLD = '700',
}
